import { getService } from "../../reducers/service";
import { serviceNames } from "../../utils/constants";

export const findSearchProfiles = async () => {
  const service = getService(serviceNames.settingsSecuritySearchProfilesAms);
  return await service.find();
};

export const findGeneralSearchProfiles = async () => {
  const service = getService(serviceNames.settingsSecuritySearchProfiles);
  return await service.find();
};

export const findSearchGroups = async (AgencyID = "") => {
  const service = getService(serviceNames.settingsSecGroupAms);
  const query = { AgencyID };
  return await service.find({ query });
};
export const deleteSearchGroup = async (id) => {
  const service = getService(serviceNames.settingsSecGroupAms);
  return await service.remove(id);
};
export const findSearchProfileGroups = async (profileID = null) => {
  const service = getService(serviceNames.settingsSecProfileGroupsAms);
  return await service.find({ query: { profileID } });
};

export const getSearchProfileGroups = async (ptsProfileID) => {
  const service = getService(serviceNames.settingsSecProfileGroupsAms);
  return await service.get(ptsProfileID);
};

export const saveSearchProfileGroups = async (data) => {
  const service = getService(serviceNames.settingsSecProfileGroupsAms);
  return await service.create(data);
};

export const findSearchClearanceLevels = async () => {
  const service = getService(serviceNames.settingsSecClearanceLevel);
  const result = await service.find();
  if (!result) return [];
  result.sort((a, b) => parseInt(a.Level) - parseInt(b.Level));
  return result;
};
export const findContactList = async (ptsPersonID) => {
  const service = getService(serviceNames.ptsContactInfo);
  const result = await service.find({
    query: {
      ptsParentID: ptsPersonID,
      PartyType: "Person",
      IsDeleted: false,
      $limit: 0,
      $sort: {
        IsDefault: -1,
      },
    },
  });

  return result.data;
};
export const findSearchUsers = async () => {
  const service = getService(serviceNames.settingsSecuritySearchUsersAms);
  return await service.find();
};

export const updateSearchUser = async (userId, data, resendCredential) => {
  const service = getService(serviceNames.settingsSecuritySearchUsersAms);
  return await service.patch(userId, data, { query: { resendCredential } });
};

export const createSearchUser = async (data) => {
  const service = getService(serviceNames.settingsSecuritySearchUsersAms);
  return await service.create(data);
};

export const deleteSearchUser = async (userId) => {
  const service = getService(serviceNames.settingsSecuritySearchUsersAms);
  return await service.remove(userId);
};

export const findSecComponents = async () => {
  const service = getService(serviceNames.settingsSecComponentAms);
  return await service.find();
};

export const findSecGroupComponents = async () => {
  const service = getService(serviceNames.settingsSecGroupComponentsAms);
  return await service.find();
};

export const saveGroupBooleans = async (data) => {
  const service = getService(serviceNames.settingsSecurityPermissionsAppsAms);
  return await service.create(data);
};

export const getGroupComponentPermission = async (groupId, componentId) => {
  const service = getService(serviceNames.settingsSecGroupComponentsAms);
  return await service.get(groupId, {
    query: { groupId, componentId },
  });
};

export const updateGroupComponentPermission = async (id, data) => {
  const service = getService(serviceNames.settingsSecGroupComponentsAms);
  return await service.patch(id, data);
};

export const updateGroupComponentPermission2 = async (data) => {
  const service = getService(serviceNames.settingsSecGroupComponentsAms);
  return await service.create(data);
};

export const findClearanceLevels = async () => {
  const service = getService(serviceNames.settingsSecurityClearanceLevels);
  return await service.find();
};

export const findUsersHistory = async (pageNumber, rowsPerPage) => {
  const service = getService(serviceNames.settingsSecurityUsersHistory);
  return await service.find({
    query: {
      pageNumber,
      rowsPerPage,
    },
  });
};

export const findSecCode = async (type) => {
  const service = getService(serviceNames.settingsSecurityCodes);
  return await service.find({
    query: { type },
  });
};

export const createSecGroup = async (data, ptsGroupID) => {
  const service = getService(serviceNames.settingsSecGroupAms);
  return await service.create(data, {
    query: { ptsGroupID },
  });
};

export const createSecProfile = async (data) => {
  const service = getService(serviceNames.settingsSecuritySearchProfilesAms);
  return await service.create(data);
};

export const getGroup = async (ptsGroupID) => {
  const service = getService(serviceNames.settingsSecGroupAms);
  return await service.get(ptsGroupID);
};

export const updateGroup = async (ptsGroupID, data) => {
  const service = getService(serviceNames.settingsSecGroupAms);
  return await service.patch(ptsGroupID, data);
};

export const getProfile = async (ptsProfileID) => {
  const service = getService(serviceNames.settingsSecuritySearchProfilesAms);
  return await service.get(ptsProfileID);
};

export const updateProfile = async (ptsProfileID, data) => {
  const service = getService(serviceNames.settingsSecuritySearchProfilesAms);
  return await service.patch(ptsProfileID, data);
};

export const removeProfile = async (ptsProfileID) => {
  const service = getService(serviceNames.settingsSecuritySearchProfilesAms);
  return await service.remove(ptsProfileID);
};

export const findDistinctPermissionTypes = async () => {
  const service = getService(serviceNames.settingsCreateNewPermissionAms);
  return await service.find();
};

export const createSecComponent = async (data) => {
  const service = getService(serviceNames.settingsCreateNewPermissionAms);
  return await service.create(data);
};

export const findDefaultPermissions = async () => {
  const service = getService(serviceNames.settingsDefaultPermissionsAms);
  return await service.find();
};

export const saveDefaultPermissions = async (data) => {
  const service = getService(serviceNames.settingsDefaultPermissionsAms);
  return await service.create(data);
};

export const saveCodePermissions = async (data) => {
  const service = getService(serviceNames.settingsCodesPermissionsAms);
  return await service.create(data);
};

export const findDeletedProfiles = async () => {
  const service = getService(serviceNames.settingsSecuritySearchProfilesAms);
  return await service.find({ query: { isDeleted: 1 } });
};

export const restoreProfile = async (ptsProfileID) => {
  const service = getService(serviceNames.settingsSecuritySearchProfilesAms);
  return await service.patch(ptsProfileID, { IsDeleted: 0 });
};
